import React from 'react';

export interface ILeaderboardTableRecordProps {
  index: string;
  stringValue: string;
  numberValue: string;
  className: string;
}

const LeaderboardTableRecord: React.FC<ILeaderboardTableRecordProps> = (props: ILeaderboardTableRecordProps) => {
    return (
        <tr className={props.className}>
            <td className="LeaderboardTableRecordCell">{props.index}</td>
            <td className="LeaderboardTableRecordMiddleCell">{props.stringValue}</td>
            <td className="LeaderboardTableRecordCell">{props.numberValue}</td>
        </tr>
    );
  }
  
  export default LeaderboardTableRecord;